import { createSlice } from "@reduxjs/toolkit";

// Filtros de la navegabilidad de puntuaciones.
const initialState = {
    filters: {
        idTipo: 0,
        // Clase en catalogo (hijos de "Clases de puntuacion"): 321 sesiones,
        // 322 planificacion.
        idClase: 0,
        idEstado: 0,
    },
    listTipos: [],
    listClases: [],
    listEstados: [],
    results: [],
}

export const puntuacionSearchSlice = createSlice({
    name: "puntuacionSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResult: (state, action) => {
            state.results = action.payload;
        },
        setListTipos: (state, action) => {
            state.listTipos = action.payload;
        },
        setListClases: (state, action) => {
            state.listClases = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
    },
});

export const { setValue, setResult
    , setListTipos, setListClases, setListEstados } = puntuacionSearchSlice.actions;
export default puntuacionSearchSlice.reducer;